$(document).ready(function () {
   $('.testimonial-slider').on('init', function (event, slick, direction) {
      $('.testimonial .testimonial-slider .content .user-profile').each(function () {
         var div_width = $('.testimonial .testimonial-slider .content .user-profile').width();
         var div_height = div_width * 1.33;
         $('.testimonial .testimonial-slider .content .user-profile').css('height', div_height + 'px');
      });
   });
   $('.testimonial-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      lazyLoad: 'ondemand',
      prevArrow: '<span class="fa fa-angle-left prev-arrow"></span>',
      nextArrow: '<span class="fa fa-angle-right next-arrow"></span>',
      responsive: [{
            breakpoint: 1200,
            settings: {
               slidesToShow: 2,
            }
         },
         {
            breakpoint: 992,
            settings: {
               slidesToShow: 1,
            }
         },
      ]
   });
});